import { Badge, Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StackOrModal } from "../../../../../mantine/components/StackOrModal/StackOrModal";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getGenerationMarketLocationNumbersColumn(
  invoices: Array<PPAInvoice>
): MRT_ColumnDef<PPAInvoice> {
  const usedGenerationMarketLocationNumbers = invoices
    .map((invoice) => invoice.generation_market_location_numbers)
    .flat();
  const usedGenerationMarketLocationNumbersSet = Array.from<string>(
    new Set(usedGenerationMarketLocationNumbers)
  );
  const uniqueUsedGenerationMarketLocationNumbers = Array.from(
    usedGenerationMarketLocationNumbersSet
  ).sort();

  return {
    accessorKey: "generation_market_location_numbers",
    header: "Erzeugungsstandort",
    enableSorting: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedGenerationMarketLocationNumbers
    },
    size: 210,
    filterFn: "arrIncludesSome",
    Cell: ({ table, row }) => {
      const search = table.getState().globalFilter ?? "";

      return (
        <StackOrModal
          elementText="Erzeugungsstandorte"
          numElements={row.original.generation_market_location_numbers.length}
        >
          {row.original.generation_market_location_numbers.map((site) => (
            <Badge color="gray" key={site} variant="outline">
              <Highlight highlight={search}>{site}</Highlight>
            </Badge>
          ))}
        </StackOrModal>
      );
    }
  };
}
